import { ModuleType } from '@services/authentication.service'

export interface NavItem {
    label: string
    icon: string
    route: string
    module: ModuleType
    moduleId: string
    requiresAdmin?: boolean
    disabledInFreeTier?: boolean
    hideInFreeTier?: boolean
    hideForLegacy?: boolean
}

export const APP_NAV_ITEMS: NavItem[] = [
    {
        label: 'Projects',
        icon: 'fa-layer-group',
        route: '/projects',
        module: 'projects',
        moduleId: 'projects'
    },
    {
        label: 'Models',
        icon: 'fa-cubes',
        route: '/models',
        module: 'models',
        moduleId: 'models'
    },
    {
        label: 'Assets',
        icon: 'fa-list-check',
        route: '/assets',
        module: 'assets',
        moduleId: 'assets',
        disabledInFreeTier: true
    },
    {
        label: 'OEE',
        icon: 'fa-gauge-high',
        route: '/oee',
        module: 'oee',
        moduleId: 'oee',
        disabledInFreeTier: true
    },
    {
        label: 'Files',
        icon: 'fa-folder-open',
        route: '/files',
        module: 'files' as ModuleType,
        moduleId: 'files'
    },
    {
        label: 'Organization',
        icon: 'fa-users-gear',
        route: '/organization',
        module: 'organization',
        moduleId: 'organization',
        requiresAdmin: true,
        disabledInFreeTier: true
    },
    {
        label: 'Billing',
        icon: 'fa-receipt',
        route: '/billing',
        module: 'billing',
        moduleId: 'billing',
        requiresAdmin: true,
        hideForLegacy: true
    },
    {
        label: 'My Shifts',
        icon: 'fa-clock',
        route: '/my-shifts',
        module: 'my-shifts' as ModuleType,
        moduleId: 'my-shifts',
        disabledInFreeTier: true
    }
]

export const APP_ADMIN_NAV_ITEM = {
    label: 'Admin',
    icon: 'fa-shield-halved',
    route: '/admin/org-settings',
    module: 'admin' as ModuleType,
}
